import { getSpacing } from '../Theme/selectors';
import { convertStyleValue } from '../../utils/js-style-to-css';
var gridPropsToCss = function gridPropsToCss(_ref) {
  var uiTheme = _ref.uiTheme,
    alignContent = _ref.alignContent,
    alignItems = _ref.alignItems,
    display = _ref.display,
    columnGap = _ref.columnGap,
    areas = _ref.areas,
    columns = _ref.columns,
    rows = _ref.rows,
    rowGap = _ref.rowGap,
    justifyContent = _ref.justifyContent,
    justifyItems = _ref.justifyItems;
  return "\n  ".concat(display ? "display: ".concat(display, ";") : '', "\n  ").concat(areas ? "grid-template-areas: ".concat(areas, ";") : '', "\n  ").concat(columns ? "grid-template-columns: ".concat(columns, ";") : '', "\n  ").concat(columnGap ? "grid-column-gap: ".concat(convertStyleValue(getSpacing(uiTheme, columnGap), 'gridColumnGap'), ";") : '', "\n  ").concat(rows ? "grid-template-rows: ".concat(rows, ";") : '', "\n  ").concat(rowGap ? "grid-row-gap: ".concat(convertStyleValue(getSpacing(uiTheme, rowGap), 'gridRowGap'), ";") : '', "\n  ").concat(alignContent ? "align-content: ".concat(alignContent, ";") : '', "\n  ").concat(alignItems ? "align-items: ".concat(alignItems) : '', "\n  ").concat(justifyContent ? "justify-content: ".concat(justifyContent, ";") : '', "\n  ").concat(justifyItems ? "justify-items: ".concat(justifyItems, ";") : '', "\n");
};
export default gridPropsToCss;